/** PURE_IMPORTS_START .._.._Observable,.._.._operator_windowToggle PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { windowToggle } from '../../operator/windowToggle';
Observable.prototype.windowToggle = windowToggle;
//# sourceMappingURL=windowToggle.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/windowToggle.js
// module id = 738
// module chunks = 0